<app-expandible-title [title]="'Importação de Planilha'"></app-expandible-title>

<div>
  <span>Mensagem: </span>
  <span class="font-weight-bold">{{data}}</span>
</div>

